import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { InfoFiles } from '../../../../services/journey.service';
import { formatOnlyDate } from '../../../../lib/dayjs';
import { FileItemRow, FileItemInfo, FileItemName, FileItemDate, FeedbackToast } from '../styled';
import FileItemViewModel from './viewModel';

interface Props {
  file: InfoFiles;
}

export default function FileItem({ file }: Props) {
  const { isLoading, handleDownload, showFeedback, handleCloseFeedback, displayName } = FileItemViewModel({ file });

  return (
    <>
      <FileItemRow onClick={handleDownload} aria-label="Baixar arquivo">
        <FileItemInfo>
          <FileItemName title={file.name}>{displayName}</FileItemName>
          <FileItemDate>upload: {formatOnlyDate(file.date)}</FileItemDate>
        </FileItemInfo>
        {isLoading ? (
          <CircularProgress size={20} sx={{ color: 'brand.darkGreen' }} />
        ) : (
          <IconButton size="small">
            <FileDownloadOutlinedIcon sx={{ width: 24, height: 24, color: 'neutrals.lead' }} />
          </IconButton>
        )}
      </FileItemRow>
      <Snackbar
        open={showFeedback}
        autoHideDuration={4000}
        onClose={handleCloseFeedback}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <FeedbackToast>
          <Typography component="p">Verifique o arquivo nos seus downloads.</Typography>
        </FeedbackToast>
      </Snackbar>
    </>
  );
}
